import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  root: {
    minHeight: 660,
  },
  sidebar: {
    marginTop: 160,
  },
  heading: {
    marginTop: 30,
    marginBottom: 20,
  },
  headingTitlePlaceholder: {
    minWidth: 300,
  },
  content: {
    marginBottom: 40,
    width: 'auto !important',
  },
  pageContentWrapper: {
    '& > div': {
      paddingBottom: 0,
    },
  },
  formPlaceholder: {
    minHeight: 660,
    width: '100%',
    maxWidth: 600,
    paddingTop: 30,
  },
}));
